export default function Services() {
  const services = [
    {
      image: 'https://static.wixstatic.com/media/11062b_ba4771109bae41c1a704b582d692a09d~mv2.jpg/v1/fill/w_292,h_300,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Luxurious%20Bathroom%20.jpg',
      title: 'Renovations',
      description: 'Update or transform your space to enhance its functionality, appearance and value. This can include layout changes, new finishes, cladding repairs, joinery upgrades and more.',
      icon: 'ri-hammer-line',
    },
    {
      image: 'https://static.readdy.ai/image/d18859bc617732e326735d9a6df55c85/c372c0ff1c26c9f12a5b0b8b89f93a29.jpeg',
      title: 'New Builds',
      description: 'Building your dream home from the ground up with quality craftsmanship and attention to every detail.',
      icon: 'ri-building-line',
    },
    {
      image: 'https://static.wixstatic.com/media/288b4c_e3f6fc496fc0465fb599e62275f34988~mv2.jpeg/v1/fill/w_292,h_300,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/AdobeStock_423316103.jpeg',
      title: 'Repairs',
      description: 'Quick and reliable repair services to fix any issues and maintain the integrity of your property.',
      icon: 'ri-tools-line',
    },
    {
      image: 'https://static.readdy.ai/image/d18859bc617732e326735d9a6df55c85/e671af9a66dd61b884a606d21beca7c3.webp',
      title: 'Extensions',
      description: 'Expand your living space with seamless extensions that blend perfectly with your existing home.',
      icon: 'ri-home-smile-line',
    },
    {
      image: 'https://static.wixstatic.com/media/288b4c_481a7a17e3e6449e89c0f0bd950daa68~mv2.jpg/v1/fill/w_291,h_300,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/interior-design-style-design-home-wallpaper-preview.jpg',
      title: 'Remodels',
      description: 'Complete remodeling services to modernize and enhance the functionality of your space.',
      icon: 'ri-paint-brush-line',
    },
    {
      image: 'https://static.readdy.ai/image/d18859bc617732e326735d9a6df55c85/ed3264297178bb2bf9b36fc2f598a1be.jpeg',
      title: 'Commercial',
      description: 'Professional commercial building and renovation services for businesses of all sizes.',
      icon: 'ri-store-line',
    },
  ];

  return (
    <section id="services" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-4 sm:mb-6"></div>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            From small repairs to complete renovations, we deliver quality craftsmanship across all our services.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div key={index} className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="relative h-56 sm:h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>
              <div className="p-5 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}